<script>
  import { DataColumn } from "svelte-headless-table";
  import { vendors, sortedVendors } from './stores/root.js'
  import { formatPrice } from './helpers.js'
  import VendorSelect from './VendorSelect.svelte'

  export let detail
  export let column 
  export let value 
  export let editingRows

  $: editRow = $editingRows.find((d) => d.id === detail.id)

  $: if (editRow && (!editRow[column] || editRow[column] !== value)) {
    editRow[column.id] = value
  }

  $: vendorName = $vendors.find((v) => v.id === value)?.name

  const isVendor = column.id === 'vendor';
  const isBool = column.id === 'donate' || column.id === 'resell';
  const isCost = column.id === 'cost';
  const isNumber = column.id === 'cost' || column.id === 'shrink';
  const isNotes = column.id === 'notes';
</script>

  <div style={isNotes ? 'min-width: 180px;' : 'min-width: 105px;'} class={!editRow && ((isVendor && !vendorName) || (isCost && !value)) ? 'bg-danger text-white' : ''}>
    {#if !editRow}
      {#if isVendor}
        {vendorName ? vendorName: "MISSING VENDOR"}
      {:else if isBool}
        {value ? "Yes" : "No"}
      {:else if isCost}
        {value ? formatPrice(Number(value), true) : "MISSING COST"}
      {:else }
        {value ? value : ""}
      {/if}
    {:else}
        {#if isVendor}
          <VendorSelect bind:vendorId={value} disabled={false} />
        {:else if isBool}
          <div class="form-check">
            <input class="form-check-input" type="checkbox" bind:checked={value}/>
          </div>
        {:else if isNumber}
          <input type="number" step="0.01" class="form-control" style="max-width: 100px" bind:value/>
        {:else if isNotes}
          <textarea class="form-control" rows="2" style="min-width: 180px" bind:value></textarea>
        {:else}
          <input type="text" class="form-control" style="max-width: 100px" bind:value/>
        {/if}
    {/if}
</div>